<template>
    <div class="view view-checkout">
        <top-bar v-if="isPortalReady"/>
        <div class="site-content" v-show="isVisible">
            <div class="container">
                <div class="row">
                    <div
                        :class="(typeof this.$route.query.operador === 'undefined') ? 'col-md-6' : 'col-md-12'"
                        :style="{
                                'max-width': '500px',
                                'margin':'auto'
                                }"
                     >
                        <div
                            class="checkout-card checkbox checkbox-aqua"
                            :class="{'checkbox-checked': curso.id == productoSeleccionado }"
                            @click="seleccionar_producto(curso.id)"
                         >


                            <div class="checkout-card-image">

                                <img
                                    :src="require('@/assets/galerias/foto_generica.jpg')"
                                    alt
                                />
                            </div>
                            </div>

                            <div class="checkout-card-info">
                                <div class="d-flex justify-content-between">
                                    <div v-if="this.$route.params.suscripcion!='suscripcion'">
                                        <div class="checkout-card-titulo">{{ categoria.categoria }}</div>
                                        <div class="checkout-card-autor">{{ categoria.autor }}</div>
                                    </div>

                                    <div v-else>
                                        <div class="checkout-card-titulo">{{ curso.producto }}</div>
                                        <div class="checkout-card-autor">{{ curso.producto }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <header v-if="this.$route.params.suscripcion=='suscripcion'" class="curso-clases-header transparente-borde" >
                            <div class="curso-clases-descripcion text-justify texto">
                                <h3 class="curso-clases-titulo-contenido">¿Qué aprenderás en este curso?</h3>
                                <div class="texto" v-html="this.portal.descripcion"></div>
                            </div>
                        </header>
                    </div>
                        <div class="row mb-30"
                            v-if="typeof this.$route.query.operador === 'undefined' && selectedPortalPasarela && selectedPortalPasarela.pasarela && selectedPortalPasarela.pasarela.is_movil<1"
                         >
                    </div>
                </div>

                <block-static destacado="checkout"/>
            </div>


        <site-footer v-if="isPortalReady" :verFooter="true"/>

            <div class="form-group text-center">

                <br>
                <label class="label-movistar" style="font-size: 17px">Desde ahora recibiras el cobro recurrente con <b>cargo a tu boleta</b> o <b>saldo Movistar</b></label>
                <br>
                <label class="label-movistar">Para tu número</label>
                <br>
                <label class="label-num-tele"><b>+{{telefono}}</b></label>
                <br>
                <label class="label-movistar" style="font-size: 2em">Felicitaciones ya puedes disfrutar del {{curso.producto}}</label>
                <br>
                <br>
                <div class="row">
                    <div class="col">
                        <button
                            :class="'btn'"
                            style="background-color: #24CCC0; border-radius: 8px;"
                            @click="accederServicio">
                            <b style="color: white">ACCEDER/DESC APP</b>
                        </button>
                    </div>
                </div>
                <br>
                <label class="label-movistar"><b>RECUERDA:</b></label>
                <div>
                    <ul>
                        <li>Puedes darte de baja en cualquier momento unviando un <b>SMS</b> con <b>el texto SALIR al 7600 sin costo</b></li>
                        <li>El precio incluye IVA</li>
                        <li>Puedes revisar los <a href="/pagina/terminos-y-condiciones_1" target="_blank"><u><b>Términos y Condiciones</b></u></a></li>
                    </ul>
                </div>
            </div>
    </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import bModal from "bootstrap-vue/es/components/modal/modal";

import TopBar from "../components/TopBar";
import Spinner from "../components/Spinner";
import {isValidEmail, isValidTelefono, rutEsValido} from "../utilities/util";
import BlockStatic from "../components/BlockStatic";
import {
    getCategoriaDeProducto,
    getProducto,
    userTieneProducto,
} from "../utilities/data";
import numeral from "numeral";
import "numeral/locales";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
numeral.locale("es");


export default {
    name: "checkout",
    components: {
        TopBar,
        bModal,
        Spinner,
        BlockStatic,
        FontAwesomeIcon,
    },
    head: {
        title() {
            return {
                inner: this.curso.producto,
            };
        },
    },
    computed: {
        isTelefonoValid() {
            return isValidTelefono(this.telefono.toString());
        },
        curso() {
            return this.portal.productos_portal
                ? getProducto(this.portal, this.$route.params.id)
                : {};
        },
        categoria() {
            return getCategoriaDeProducto(this.portal, this.curso.id);
        },
        producto() {
            return this.portal.productos_portal.find(
                (p) => p.id == this.$route.params.id
            );
        },
        ...mapState(["portal", "user", "site", "isPortalReady"]),
        ...mapGetters(["userId"]),
    },
    watch: {
        portal(val, old) {
            if (val) {
                if (typeof val.productos_portal !== "undefined") {
                    //Comento segundo llamado de start para evitar llamados adicionales en los landings
                    //this.start();
                }
            }
        },
        selectedPortalPasarela(val, old) {
            if (val.pasarela.pasarela == "Movistar") {
                //this.movistarIP();
            }
        },
    },
    data() {
        return {
            confirm_of_user: false,
            selectedPortalPasarela: {},
            productoSeleccionado: this.$route.params.id,
            telefono_suscribir: "",
            header: false,
            msisdnEntel: "",
            telefono: this.$route.params.telefono,
        };
    },
    methods: {
        cargar_pasarela(id_product) {
            if (
                this.portal.productos_portal.filter(
                    (producto) => producto.id == id_product
                ).length > 0
            ) {
                // Cargar pasarelas del producto/portal
                this.portalPasarelas = this.portal.productos_portal
                    .filter((producto) => producto.id == id_product)[0]
                    .productos_pasarelas.map((pp) => {
                        return {
                            id_portal_pasarela: pp.id_portal_pasarela,
                            pasarela: pp.productos_portal_pasarela[0].pasarelas[0],
                        };
                    });

                if (this.portalPasarelas.length > 0 && this.msisdnEntel == "") {
                    //Si el query route posee operador se selecciona una pasarela de operadores
                    if (typeof this.$route.query.operador !== "undefined") {

                        let firstPasarelaMovil = this.portalPasarelas.find(({pasarela}) => {
                            //Encontrar pasarela movil
                            if (pasarela.is_movil) {
                                return pasarela;
                            }
                        });

                        if (typeof firstPasarelaMovil !== "undefined") {
                            this.selectedPortalPasarela = firstPasarelaMovil
                        } else {
                            this.selectedPortalPasarela = this.portalPasarelas[0];
                        }

                    } else {
                        this.selectedPortalPasarela = this.portalPasarelas[0];
                    }
                }

                //SELECCIONAR MEOTOD PAGO
                dataLayer.push({
                    event: "checkoutOption",
                    ecommerce: {
                        checkout_option: {
                            actionField: {
                                step: 2,
                                option: this.selectedPortalPasarela.pasarela.pasarela,
                            },
                        },
                    },
                });
            } else {
                // El id del curso no existe.
                this.$router.replace({name: "error404"});
            }
        },
        start() {
            this.$log.warn('start')
            this.cargar_pasarela(
                this.productoSeleccionado == false
                    ? this.$route.params.id
                    : this.productoSeleccionado
            );
            this.isVisible = true;
        },
        loadDataUser() {
            // TODO: manejar cuando no existe el video
            if (!this.site.didLoadUser) {
                // Aún está cargando.
                setTimeout(() => {
                    this.loadDataUser();
                }, 100);
                return false;
            }
            if (!this.site.didLoadUser) {
                /*console.log(
                  getCategoriaDeProducto(this.portal, this.productoSeleccionado)
                );*/
                this.$router.push({
                    name: "curso",
                    params: {
                        guid: getCategoriaDeProducto(this.portal, this.productoSeleccionado)
                            .guid,
                    },
                });
                return false;
            }
            // TODO: manejar cuando no existe el video
            if (!this.site.didLoadUserCompras) {
                // Aún está cargando.
                setTimeout(() => {
                    this.loadDataUser();
                }, 100);
                return false;
            }

        },
        accederServicio(){
            window.location.href = "https://cms.topclass.academy/thinkific/auth";
        },

    },
    mounted() {
        this.$log.warn('mounted1')
        if (this.portal.productos_portal) {
            this.$log.warn('mounte2')
            this.start();
        }
    },
    created() {
        this.loadDataUser();
        document.head.querySelector("meta[name=description]").content =
            this.$route.params.suscripcion != "suscripcion"
                ? this.curso.productos_categorias[0].categorias_productos[0].descripcion
                : this.portal.descripcion;

        this.operadorParametro = this.$route.query.operador;

        if (typeof this.user.telefono !== "undefined" && this.user.telefono != "") {
            this.telefono = this.user.telefono;
        }

        localStorage.setItem(
            "telefono_suscribir",
            typeof this.user.telefono !== "undefined" && this.user.telefono != ""
                ? this.user.telefono
                : ""
        );
        localStorage.setItem("header", false);
    },
};
</script>
